module.exports = __webpack_public_path__ + "img/sw_get.2265f13.png";